var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 2.5V10.3667C2.00033 11.1134 2.00033 11.4865 2.14565 11.7717C2.27348 12.0226 2.47731 12.227 2.72819 12.3548C3.01313 12.5 3.38632 12.5 4.1316 12.5H7.86905C8.61433 12.5 8.98698 12.5 9.27192 12.3548C9.5228 12.227 9.72731 12.0226 9.85514 11.7717C10.0003 11.4868 10.0003 11.114 10.0003 10.3687V2.5M2.00033 2.5H3.33366M2.00033 2.5H0.666992M3.33366 2.5H8.66699M3.33366 2.5C3.33366 1.87874 3.33366 1.56827 3.43515 1.32324C3.57048 0.996538 3.82987 0.736819 4.15658 0.601494C4.4016 0.5 4.7124 0.5 5.33366 0.5H6.66699C7.28825 0.5 7.59887 0.5 7.8439 0.601494C8.17061 0.736819 8.4301 0.996538 8.56543 1.32324C8.66692 1.56827 8.66699 1.87875 8.66699 2.5M8.66699 2.5H10.0003M10.0003 2.5H11.3337",
    stroke: "#990B0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRed);
export default __webpack_public_path__ + "static/media/remove-red.7f13705b68ec3d5869287dbb04f3c5d2.svg";
export { ForwardRef as ReactComponent };